import React from 'react';

import { Spin } from 'antd';
import { Navigate, useLocation } from 'react-router-dom';

import './ProtectedRoute.scss';

export type ProtectedRouteProps = {
  isAuthenticated: boolean;
  isAccountLoading: boolean;
  children: JSX.Element;
};

const ProtectedRoute = ({ isAuthenticated, children, isAccountLoading }: ProtectedRouteProps) => {
  const location = useLocation();
  if (isAccountLoading) {
    return (
      <div className="protected-route">
        <Spin />
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} />;
};

export default ProtectedRoute;
